import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import "./public-path";
// import routes from "./router";
import {router} from './router';
import store from "./store";
// 引入全局工具类api
import Utils from './common/utils'
// 引入echarts组件
import './plugins/echarts/echarts-settings'
import VueTouch from 'vue-touch'
// 按需导入iview-ui
import "./plugins/iview/ui-settings.js";
import './plugins/iview/index.less';
// 导入C30云平台公共UI 组件
import dateduUI from "ui-library-datedu-sshu";
import 'ui-library-datedu-sshu/lib/ui-library-datedu-sshu.css'
import 'echarts/map/js/china'
// 日期格式化插件
import moment from 'moment'
Vue.prototype.$moment = moment;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.use(VueTouch, {name: 'v-touch'});
Vue.prototype.$utils = Utils;
// 添加全局bus
const Bus = new Vue();
const __qiankun__ = window.__POWERED_BY_QIANKUN__;


Vue.use(dateduUI)

Vue.config.productionTip = false;

// let subRouter = null;
let instance = null;

export async function bootstrap ({data, utils, service, emitFnc,baseUrl}) {
    //挂载主应用下发的store
    Vue.prototype.$mainData = data;
    // 把工具函数挂载在vue $mainUtils对象
    Vue.prototype.$mainUtils = utils;
    Vue.prototype.$mainService = service;
    // 把mainEmit函数一一挂载
    Object.keys(emitFnc).forEach(i => {
        Vue.prototype[i] = emitFnc[i]
    })
    Vue.prototype.$baseUrl = baseUrl;
}


export async function mount ({data = {},ROUTES, routerBase} = {}) {
    // router = new VueRouter({
    //     base: window.__POWERED_BY_QIANKUN__ ? "/"+routerBase : "/",
    //     mode: "history",
    //     // routes: __qiankun__ ? routeMatch(ROUTES, routerBase) : routes
    // });
    instance = new Vue({
        data: {
            Bus
        },
        router,
        store,
        render: h => h(App, {props: data})
    }).$mount("#app");
}

export async function unmount () {
    instance.$destroy();
    instance = null;
    // subRouter = null;
}

// 单独开发环境
__qiankun__ || mount();

